import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  userData: null,
  error: null,
  showResetPasswordLink: false,
  masterAuthToken: null,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.token = action.payload.token;
      state.userData = action.payload.userData;
      state.isAuthenticated = true;
      state.error = null;
    },
    loginFailure(state, action) {
      state.error = action.payload;
    },
    logout(state) {
      state.token = null;
      state.userData = null;
      state.error = null;
      state.isAuthenticated = false;
      state.masterAuthToken = null;
    },
    updateProfile(state, action) {
      state.userData = action.payload.userData;
    },
    masterAuthSuccess(state, action) {
      state.masterAuthToken = action.payload.token;
    },
    masterAuthClear(state) {
      state.masterAuthToken = null;
    },
  },
});

export const { loginSuccess, loginFailure, logout, updateProfile, masterAuthSuccess, masterAuthClear } = loginSlice.actions;
export default loginSlice.reducer;
